import React, { useCallback, useContext, useState } from 'react';
import { LocalizationContext } from 'app/localization/Context';
import { TemperatureSlider } from '../../../general-components/Slider/AdvanceSliders';
import { BindActionType, BindConditionType } from 'app/model/Bind';
import { EcoThermostatControl, SednaControl, ThermostatOnOff } from '../../device/deivce-detail/device-control/Thermostat/ThermostatControl';
import { DeviceType, useDeviceStub } from 'app/model/Device';
import { createBindDeviceSpecialInfoObject, getBindTemplate } from 'app/model/BindData';

import { ReactComponent as IconX } from 'images/general/x.svg';
import { ReactComponent as IconBack } from 'images/general/back.svg';
import { ReactComponent as IconBackBlack } from 'images/general/back-black.svg';

import './ThermostatSpecial.scss'


export default function ThermostatSpecialPage(props) {
    if (props.pageData.stage === 'if') {
        return React.createElement(GetTemperaturePage, props);
    } else {
        return React.createElement(GetThermostatStatePage, props);
    }
}

function GetTemperaturePage({
    dismissHandler,
    pageData, back,
    preBind, pushState }) {
    const l = useContext(LocalizationContext);
    const s = l.strings;
    const b = s.createBindProcess;

    const [selectedCond, setSelectedCond] = useState("higher");
    const [tempVal, setTempVal] = useState(25); // also change initalValue

    const device = pageData.device;

    const nextClick = useCallback(() => {
        const _preBind = { ...preBind };
        let _conditionInfos = [..._preBind.conditionInfos];
        _conditionInfos = _conditionInfos.filter(info =>
            (info.data.condition_type !== BindConditionType.device) ||
            (info.data.device_mac !== device.mac)
        );
        const condTemplate = getBindTemplate(true, device, l);
        _conditionInfos.push(createBindDeviceSpecialInfoObject(true, condTemplate.icon, device.name, {
            condition_type: BindConditionType.device,
            device_mac: device.mac,
            device_type: device.type,
            temperature: {
                value: tempVal,
                comparison: { "lower": 0, "equal": 1, "higher": 2 }[selectedCond]
            }
        }, l));
        _preBind.conditionInfos = _conditionInfos;

        pushState({ preBind: _preBind, pageData: { name: 'main' } });
    }, [tempVal, selectedCond, preBind, pushState, device, l]);

    return (
        <div className="create-bind-page-content">
            <IconBack className="nav-icon" /> <div className="nav-button" onClick={() => { back(); }} />
            <IconX className="nav-icon-secondary" /> <div className="nav-button-secondary" onClick={dismissHandler} />

            <div className="header">{b.whenTempIf}</div>
            <div className="info" style={{ marginBottom: 8 }}>{b.chooseOneOfTheseConditions}</div>

            <div className="temp-condition-container">
                <div className={selectedCond === "lower" ? "item selected" : "item"}
                    onClick={() => {
                        setSelectedCond("lower")
                    }}>
                    <div className="highlight">&#60;</div>
                    <div className="text">{b.whenConditionComparison.lower}</div>
                </div>
                <div className={selectedCond === "equal" ? "item selected" : "item"}
                    onClick={() => {
                        setSelectedCond("equal")
                    }}>
                    <div className="highlight">=</div>
                    <div className="text">{b.whenConditionComparison.equal}</div>
                </div>
                <div className={selectedCond === "higher" ? "item selected" : "item"}
                    onClick={() => {
                        setSelectedCond("higher")
                    }}>
                    <div className="highlight">&#62;</div>
                    <div className="text">{b.whenConditionComparison.higher}</div>
                </div>
            </div>

            <div className="temp-slider-container" dir="ltr">
                <TemperatureSlider rtl={false} min={-10} max={70} initalValue={25} step={1} onChange={setTempVal} />
            </div>
            {/* <div className="temp-slider-info" dir="ltr">
                <div className="text">-10˚C</div>
                <div />
                <div className="text">70˚C</div>
            </div> */}

            <div className="big-button blue-bottom bottom-next-button" onClick={nextClick}>
                <div>{b.next}</div> <IconBackBlack className="icon-180" />
            </div>
        </div>
    );
}

function GetThermostatStatePage({
    dismissHandler,
    pageData, back,
    preBind, pushState }) {
    const l = useContext(LocalizationContext);
    const s = l.strings;
    const b = s.createBindProcess;

    const device = pageData.device;
    const deviceName = device.name;
    const [deviceToShow, deviceToSend] = useDeviceStub({
        mac: device.mac,
        type: device.type,
        sub_type: device.sub_type,
        set_point_min: device.set_point_min,
        set_point_max: device.set_point_max,
    });

    const nextClick = useCallback(() => {
        const _preBind = { ...preBind };
        let _actionInfos = [..._preBind.actionInfos];
        _actionInfos = _actionInfos.filter(info =>
            (info.data.action_type !== BindActionType.device) ||
            (info.data.device_mac !== device.mac)
        );
        const actTemplate = getBindTemplate(false, device, l);

        if (device.type === DeviceType.sedna) {
            if (deviceToSend["is_on"] === true) {
                _actionInfos.push(createBindDeviceSpecialInfoObject(false, actTemplate.icon, device.name, {
                    action_type: BindActionType.device,
                    device_mac: device.mac,
                    device_type: device.type,
                    is_on: true,
                    mode: deviceToSend["mode"],
                    set_point: deviceToSend["set_point"],
                    motor_speed: deviceToSend["motor_speed"],
                    scenario: deviceToSend["scenario"],
                }, l));
            } else {
                _actionInfos.push(createBindDeviceSpecialInfoObject(false, actTemplate.icon, device.name, {
                    action_type: BindActionType.device,
                    device_mac: device.mac,
                    device_type: device.type,
                    is_on: false,
                }, l));
            }
        } else if (device.type === DeviceType.hinavaEcoThermostat) {
            if (deviceToSend["is_on"] === true) {
                _actionInfos.push(createBindDeviceSpecialInfoObject(false, actTemplate.icon, device.name, {
                    action_type: BindActionType.device,
                    device_mac: device.mac,
                    device_type: device.type,
                    is_on: true,
                    mode_setting: deviceToSend["mode_setting"],
                    set_point: deviceToSend["set_point"],
                    fan_setting: deviceToSend["fan_setting"],
                    turbo_setting: deviceToSend["turbo_setting"],
                }, l));
            } else {
                _actionInfos.push(createBindDeviceSpecialInfoObject(false, actTemplate.icon, device.name, {
                    action_type: BindActionType.device,
                    device_mac: device.mac,
                    device_type: device.type,
                    is_on: false,
                }, l));
            }
        }

        _preBind.actionInfos = _actionInfos;
        pushState({ preBind: _preBind, pageData: { name: 'main' } });
    }, [deviceToSend, preBind, pushState, device, l]);

    return (
        <div className="create-bind-page-content">
            <IconBack className="nav-icon" /> <div className="nav-button" onClick={() => { back(); }} />
            <IconX className="nav-icon-secondary" /> <div className="nav-button-secondary" onClick={dismissHandler} />

            <div className="header"
                style={{ marginLeft: 8, marginRight: 8 }}>
                {b.then} {deviceName}
            </div>
            <div className="info"
                style={{ marginBottom: 8, marginLeft: 8, marginRight: 8 }}>
                {b.goToState}
            </div>

            <ThermostatOnOff device={deviceToShow} />
            {(device.type === DeviceType.sedna) ?
                <SednaControl device={deviceToShow} forLightBackground={false} /> :
                ((device.type === DeviceType.hinavaEcoThermostat) ?
                    <EcoThermostatControl device={deviceToShow} forLightBackground={false} /> : null)}

            <div style={{ width: 10, height: 64 + 8 }} />

            {/* vvvv in CreateScenario.scss vvvv */}
            <div className="full-blue-button" onClick={nextClick}>
                <div>{b.next}</div> <IconBackBlack className="icon-180" />
            </div>
        </div>
    );
}
